import { CategoryMapper } from '@/utils/mappers/CategoryMapper';
import { defineStore } from 'pinia';

export const useCategoryStore = defineStore('category', {
    state: () => ({
        _categories: null as Category[] | null,
        hiddenCategories: null as string[] | null
    }),
    actions: {
        setCategories(categories: CategoryApi[]) {
            const categoriesList: Category[] = [];
            categories.forEach((category: CategoryApi) => {
                categoriesList.push(CategoryMapper.getCategoryFromData(category));
            });

            this._categories = categoriesList || [];
        }
    },
    getters: {
        getProductsByCategory:
            (state) =>
            (categoryId: string): ProductInCategory[] => {
                const products = state._categories?.find((cat) => cat.id === categoryId)?.products;
                return products ?? [];
            },
        categories(state) {
            if (!state._categories) {
                return null;
            }

            const hidden = state.hiddenCategories || [];
            return state._categories.filter((category) => !hidden.includes(category.id));
        }
    }
});
